import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { MasterHelpModel } from '../models/MasterHelp.model';
import { InfraService } from './infra.service';

@Injectable()
export class MasterHelpService {
  private configCoreUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configCoreUrl = data.WebEndPoint2 + 'help';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getMasterHelp(StepId: number): Observable<MasterHelpModel> {
    return this.http.get<MasterHelpModel>(`${this.configCoreUrl}/getHelpDescriptions/${StepId}`);
  }

  public getMasterHelpById(MasterHelpId: number): Observable<MasterHelpModel> {
    return this.http.get<MasterHelpModel>(`${this.configCoreUrl}/getHelpDescriptionsById/${MasterHelpId}`);
  }

  public getAllMasterHelp(): Observable<MasterHelpModel[]> {
    return this.http.get<MasterHelpModel[]>(`${this.configCoreUrl}/getAllMasterHelp`);
  }

  public UpdatedHelp(stepId: number, displayContent: boolean) {
    return this.http.get(`${this.configCoreUrl}/updatedHelp/${stepId}/${displayContent}`);
  }

  public UpdatedHelpById(MasterHelpId: number, displayContent: boolean) {
    return this.http.post(`${this.configCoreUrl}/updatedHelpById/${MasterHelpId}/${displayContent}`, {});
  }

  // File Download
  public downloadFileByBlob(fileContent: any, fileName: string, contentType: string) {
    const blob: any = new Blob([fileContent], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('href', url);
    downloadLink.setAttribute('download', fileName);
    downloadLink.style.visibility = 'hidden';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}
